import React from 'react';
import { MessageCircle, Users, ArrowRight } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const WHATSAPP_CHANNEL_URL = "https://whatsapp.com/channel/0029VbC0Tgn9hXExy6b4X10T";

export const WhatsAppSection = () => {
  const { t } = useLanguage();

  return (
    <section
      data-testid="whatsapp-section"
      className="py-16 bg-gradient-to-r from-oar-blue to-oar-blue-dark relative overflow-hidden"
    >
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-32 h-32 bg-green-500/10 rounded-full -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-48 h-48 bg-green-500/10 rounded-full translate-x-1/4 translate-y-1/4" />
      
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Icon & Text */}
          <div className="flex items-center gap-6 text-center md:text-left">
            <div className="hidden md:flex w-20 h-20 bg-green-500 rounded-full items-center justify-center shadow-lg shadow-green-500/30 flex-shrink-0">
              <MessageCircle className="w-10 h-10 text-white" />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">
                {t('whatsapp.title')}
              </h3>
              <p className="text-white/80 text-base md:text-lg max-w-lg">
                {t('whatsapp.description')}
              </p>
            </div>
          </div>

          {/* CTA Button */}
          <a
            href={WHATSAPP_CHANNEL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-join-btn"
            className="group flex items-center gap-3 bg-green-500 hover:bg-green-600 text-white rounded-full px-8 py-4 font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:shadow-green-500/30 flex-shrink-0"
          >
            <MessageCircle className="w-6 h-6" />
            {t('whatsapp.cta')}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>

        {/* Stats */}
        <div className="mt-8 pt-8 border-t border-white/20 flex flex-wrap items-center justify-center gap-8 text-white/70 text-sm">
          <div className="flex items-center gap-2">
            <Users className="w-4 h-4" />
            <span>{t('whatsapp.community')}</span>
          </div>
          <div className="flex items-center gap-2">
            <MessageCircle className="w-4 h-4" />
            <span>{t('whatsapp.updates')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};
